import React from "react";
import { Card, IconButton, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Div from "@jumbo/shared/Div";
import { useTranslation } from "react-i18next";
import { resolvePosUserId } from "app/services/api/accessSystemPosUsers";

/**
 * One POS user row — layout aligned with AccessSystem VoucherSeriesListItem.
 */
const PosUserListItem = ({ row, onEdit }) => {
  const { t } = useTranslation();
  const id = resolvePosUserId(row);
  const active = row.active !== false;

  return (
    <Card sx={{ mb: 1 }}>
      <Div
        sx={{
          px: 3,
          py: 1.5,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: "space-between",
          flexWrap: "wrap",
          rowGap: { xs: 1.5, md: 0 },
        }}
      >
        <Div sx={{ flex: { xs: "1 1 100%", md: 1 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t("pages.pos.users.colFirstName")}
          </Typography>
          <Typography variant="body1">
            {row.firstName ?? row.first_name ?? "—"}
          </Typography>
        </Div>

        <Div sx={{ flex: { xs: "1 1 100%", md: 1 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t("pages.pos.users.colLastName")}
          </Typography>
          <Typography variant="body1">
            {row.lastName ?? row.last_name ?? "—"}
          </Typography>
        </Div>

        <Div sx={{ flex: { xs: "1 1 100%", md: 0.8 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t("pages.pos.users.colPin")}
          </Typography>
          <Typography variant="body1">
            {row.pin != null ? String(row.pin) : "—"}
          </Typography>
        </Div>

        <Div sx={{ flex: { xs: "1 1 100%", md: 0.7 }, minWidth: 0, px: 1 }}>
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t("pages.pos.users.colActive")}
          </Typography>
          <Typography variant="body1">
            {active ? t("pages.pos.users.activeYes") : t("pages.pos.users.activeNo")}
          </Typography>
        </Div>

        <Div
          sx={{
            flex: { xs: "1 1 auto", md: 0 },
            px: 1,
            alignSelf: { xs: "flex-end", md: "center" },
          }}
        >
          <Typography
            fontSize="12px"
            variant="h6"
            color="text.secondary"
            mb={0.25}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {t("pages.pos.users.colActions")}
          </Typography>
          <Div
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 0.5,
              minWidth: 40,
            }}
          >
            <Tooltip title={t("buttons.edit")} placement="top-start">
              <span>
                <IconButton
                  size="small"
                  onClick={() => onEdit(row)}
                  disabled={!id}
                  aria-label={t("buttons.edit")}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </Div>
        </Div>
      </Div>
    </Card>
  );
};

export default PosUserListItem;
